/**
 * Platform Pages Copy
 *
 * Centralized copy for platform pages including user profiles, artist profiles,
 * and other authenticated user experiences.
 *
 * This file contains all user-facing text for platform interactions to enable
 * centralized copy management and consistent brand voice.
 */

export const platformPagesCopy = {
  userProfile: {
    tabs: {
      activity: {
        label: 'Activity',
        descriptor: (name: string) => `What ${name} is sharing and doing on Coral`
      },
      alignments: {
        label: 'Alignments',
        descriptor: (name: string) => `People ${name} is aligned with`
      },
      coral: {
        label: 'Coral',
        descriptor: (name: string) => `Artists ${name} is backing on Coral`
      }
    }
  },

  artistProfile: {
    tabs: {
      activity: {
        label: 'Activity',
        descriptor: (name: string) => `What ${name} is releasing and contributing`
      },
      works: {
        label: 'Works',
        descriptor: (name: string) => `Explore and discuss ${name}'s music catalogue`
      },
      conversation: {
        label: 'Conversation',
        descriptor: (name: string) => `Public discussions about ${name} and their work`
      },
      alignments: {
        label: 'Alignments',
        descriptor: (name: string) => `People ${name} is aligned with`
      },
      contributors: {
        label: 'Contributors',
        descriptor: (name: string) => `People backing ${name}`
      }
    }
  },

  community: {
    tabs: {
      activity: {
        label: 'Activity',
        descriptor: (name: string) => `Recent releases and dancefloor activity in ${name}`
      },
      dancefloor: {
        descriptor: (name: string) => `The ${name} dancefloor — send a gesture to the scene`
      },
      discussion: {
        label: 'Discussion',
        descriptor: (name: string) => `Conversations happening across ${name} artists`
      },
      members: {
        label: 'Contributors',
        descriptor: (name: string) => `People backing artists in the ${name} community`
      },
      artists: {
        label: 'Artists',
        descriptor: (name: string) => `Artists in the ${name} community`
      }
    },
    emptyStates: {
      activity: 'No activity yet from artists in this community',
      dancefloor: (name: string) => `Be the first to send a gesture on the ${name} dancefloor`,
      discussion: "No discussions yet \u2014 be the first to start a conversation on an artist's content",
      members: 'No contributors yet \u2014 back an artist in this genre to join',
      artists: 'No artists found for this genre'
    },
    dashboardCard: {
      heading: 'Across your communities'
    },
    header: {
      coralsContributing: (n: number) => `${n} corals`,
      moneyFlowing: (amount: number, artistCount: number) => `$${amount.toLocaleString()} monthly to ${artistCount} artists`,
      memberCount: (n: number) => `${n} contributors`,
      memberAcknowledgment: (backed: number, total: number) => `You back ${backed} of ${total} artists in this community`
    },
    narrativeLink: 'See the discussions'
  }
};
